import Line from "./Line";
import Skills from "./Skills";

const About: React.FC<{}> = () => {
  return (
    <div className="text-white dvh flex flex-col sm:flex-row pt-0 sm:pt-20 mb-10" id="about">
      <div className="flex justify-center items-center my-8 sm:my-0 sm:mr-12 flex-shrink-0">
        <img
          src="/images/me.png"
          alt="Profile"
          className="w-64 h-64 sm:w-96 sm:h-96 rounded-xl border-4 border-cyan-500 shadow-lg transition-transform object-cover"
        />
      </div>
      <div className="flex flex-col justify-center flex-grow px-4 sm:px-0">
        <p className="text-lg"> Hello!
          <strong className="text-cyan-500"></strong>
        </p>
        <p className="text-lg">
          <strong className="text-cyan-500">My name is</strong>
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold mt-2">Thomas Fogarty</h1>
        {/* <h2 className="text-xl sm:text-2xl text-gray-300">Web Developer</h2> */}
        <div className="mt-4">
          <h3 className="leading-6 text-sm sm:text-base">
            I am a web developer with a Master’s degree in Computer Science and hands-on experience building modern, scalable web applications. My expertise includes JavaScript and TypeScript, PHP, relational databases (MySQL), and contemporary frameworks such as React and Laravel. I focus on creating clean, maintainable code and delivering performant, user-centered web solutions.

            I have worked on production web applications serving large user bases, contributing to both frontend and backend development. My experience includes integrating and transforming data from XML, iCal, and JSON feeds, designing and maintaining database schemas, debugging and optimizing backend logic, and collaborating with teams using Git-based workflows. With a strong computer science foundation, I quickly adapt to new web technologies, optimize application performance, and build reliable full-stack solutions.
          </h3>
        </div>
        <Skills />
      </div>
      <Line />
    </div>
  );
};

export default About;
